import { HeadButtons, PageHeadContainer, PageTitle } from 'components/PageHead';
import ProfileNavigation from 'components/profileNavigation';
import ProfileLink from 'components/profileNavigation/Link';
import React, { FC, useMemo } from 'react';
import SettingsButtonRoutes from './ButtonRoutes';
import SettingsRoutes from './Routes';

type ContextType = Record<string, never>;
export const MenteeEditContext = React.createContext({} as ContextType);
const { Provider } = MenteeEditContext;

const Settings: FC = ({ children }) => {
  const value = useMemo(() => ({}), []);

  return <Provider value={value}>{children}</Provider>;
};

const Head: FC = () => {
  return (
    <PageHeadContainer>
      <PageTitle>
        <h1>Paramètres</h1>
      </PageTitle>
      <HeadButtons>
        <SettingsButtonRoutes />
      </HeadButtons>
    </PageHeadContainer>
  );
};

const baseURL = '/settings/';
const Navigation: FC = () => {
  return (
    <ProfileNavigation>
      <ProfileLink to={baseURL}>Informations</ProfileLink>
      <ProfileLink to={baseURL + 'password'}>Mot de passe</ProfileLink>
    </ProfileNavigation>
  );
};

const Usage: FC = (props) => {
  return (
    <Settings {...props}>
      <Head />
      <Navigation />
      <SettingsRoutes />
    </Settings>
  );
};

export default Usage;
